import React from 'react';
import './Logo.css';
import Logotype from '../../img/header-logo.svg'

class Logo extends React.Component {
    render() {
        return (
            <div className="col-xl-2 col-lg-2 col-md-3 header-logo col-sm-4 col-4">
                <img src={Logotype} alt="HeaderLogo" title="HeaderLogo"/>
            </div>
        )
    }
}

export default Logo;